<template>
  <!-- <svg
    width="162px"
    height="120px"
    viewBox="0 0 81 60"
    version="1.1"
    id="spritContainer"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        x1="26.535719%"
        y1="50.846716%"
        x2="116.442923%"
        y2="46.698877%"
        id="linearGradient-1"
      >
        <stop stop-color="#E5A95B" offset="0%" />
        <stop stop-color="#BB6709" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="12.955178%"
        y1="99.72655%"
        x2="73.459671%"
        y2="13.323563%"
        id="linearGradient-2"
      >
        <stop stop-color="#005AA0" offset="0%" />
        <stop stop-color="#0099CC" offset="46.85%" />
        <stop stop-color="#3DA1CD" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="114.348048%"
        y1="29.02247%"
        x2="11.013698%"
        y2="61.306811%"
        id="linearGradient-3"
      >
        <stop stop-color="#D7E7AF" offset="0%" />
        <stop stop-color="#0099CC" stop-opacity="0" offset="95.16%" />
      </linearGradient>
      <linearGradient
        x1="49.456591%"
        y1="19.249155%"
        x2="50.836587%"
        y2="55.695864%"
        id="linearGradient-4"
      >
        <stop stop-color="#006EB6" offset="10.54%" />
        <stop stop-color="#3DA1CD" stop-opacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="59.850829%"
        y1="19.00331%"
        x2="48.851154%"
        y2="53.616083%"
        id="linearGradient-5"
      >
        <stop stop-color="#006EB6" offset="10.54%" />
        <stop stop-color="#3DA1CD" stop-opacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="44.907523%"
        y1="26.183409%"
        x2="59.458736%"
        y2="100.659587%"
        id="linearGradient-6"
      >
        <stop stop-color="#005AA0" offset="0%" />
        <stop stop-color="#005AA0" stop-opacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="35.749254%"
        y1="58.360047%"
        x2="141.61656%"
        y2="-2.131224%"
        id="linearGradient-7"
      >
        <stop stop-color="#005AA0" offset="0%" />
        <stop stop-color="#0099CC" offset="73.89%" />
        <stop stop-color="#3DA1CD" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="123.782474%"
        y1="34.994164%"
        x2="12.508179%"
        y2="55.825619%"
        id="linearGradient-8"
      >
        <stop stop-color="#005AA0" offset="0%" />
        <stop stop-color="#005AA0" stop-opacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50.862708%"
        y1="-10.320113%"
        x2="49.298543%"
        y2="74.247237%"
        id="linearGradient-9"
      >
        <stop stop-color="#FCD475" stop-opacity="0" offset="0%" />
        <stop stop-color="#E7A100" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="77.378911%"
        y1="97.947489%"
        x2="34.234616%"
        y2="16.25232%"
        id="linearGradient-10"
      >
        <stop stop-color="#D34C3A" offset="0%" />
        <stop stop-color="#EC6D4E" offset="28.74%" />
        <stop stop-color="#EF8465" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-14.199202%"
        y1="36.710025%"
        x2="73.544897%"
        y2="53.857414%"
        id="linearGradient-11"
      >
        <stop stop-color="#FABF13" offset="0.25%" />
        <stop stop-color="#EF8465" stop-opacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50.203071%"
        y1="65.128279%"
        x2="49.913225%"
        y2="28.267902%"
        id="linearGradient-12"
      >
        <stop stop-color="#DB4F3C" stop-opacity="0" offset="0%" />
        <stop stop-color="#D34C3A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="54.40848%"
        y1="64.353009%"
        x2="40.067835%"
        y2="17.67546%"
        id="linearGradient-13"
      >
        <stop stop-color="#DB4F3C" stop-opacity="0" offset="0%" />
        <stop stop-color="#D34C3A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="51.461832%"
        y1="78.685193%"
        x2="45.16128%"
        y2="-3.460607%"
        id="linearGradient-14"
      >
        <stop stop-color="#DB4F3C" stop-opacity="0" offset="0%" />
        <stop stop-color="#D34C3A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="16.997544%"
        y1="1.275783%"
        x2="77.446567%"
        y2="90.16685%"
        id="linearGradient-15"
      >
        <stop stop-color="#EC6D4E" offset="48.36%" />
        <stop stop-color="#EF8465" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="53.810589%"
        y1="96.292601%"
        x2="45.699005%"
        y2="15.890515%"
        id="linearGradient-16"
      >
        <stop stop-color="#DB4F3C" stop-opacity="0" offset="0%" />
        <stop stop-color="#D34C3A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="55.916633%"
        y1="-5.403576%"
        x2="49.431007%"
        y2="72.509027%"
        id="linearGradient-17"
      >
        <stop stop-color="#FCD475" stop-opacity="0" offset="0%" />
        <stop stop-color="#E7A100" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group" transform="translate(-0.000327, 0.000311)" fill-rule="nonzero">
        <path
          d="M72.764327,53.2666886 L66.771327,52.8786886 L69.522327,48.5706886 L67.679327,47.9136886 L62.237327,52.5846886 L15.834327,49.5796886 C14.305327,49.4806886 12.885327,50.5356886 12.667327,52.0526886 C12.663327,52.0796886 12.660327,52.1066886 12.656327,52.1336886 C12.446327,53.8706886 13.920327,55.3616886 15.670327,55.3596886 L48.625327,55.3206886 L56.585327,59.3266886 L59.280327,58.8106886 L53.853327,55.3136886 L70.687327,55.2936886 L72.764327,53.2666886 Z"
          id="樹枝"
          data-spirit-id="樹枝"
          fill="url(#linearGradient-1)"
        />
        <g id="藍-身體" transform="translate(37.792327, 8.130001)">
          <path
            d="M4.023,36.1156874 C5.152,32.6106874 7.376,29.4626874 10.389,27.4796874 C6.323,24.7526874 4.097,19.7456874 5.158,14.6576874 C5.842,11.3766874 7.768,8.67368738 10.34,6.93268738 L12.673,0.263687377 C12.775,-0.0273126232 13.156,-0.0933126232 13.35,0.145687377 L16.715,4.29468738 C17.484,4.32568738 18.26,4.41268738 19.038,4.57568738 L33.878,7.67068738 C34.616,7.82468738 35.326,8.03968738 36.009,8.29868738 L40.718,5.85768738 C40.994,5.71468738 41.32,5.92968738 41.297,6.23968738 L40.77,13.2786874 C42.431,15.9036874 43.116,19.1506874 42.432,22.4316874 C41.1,28.8196874 35.07,33.0196874 28.704,32.1836874 C28.657,32.5086874 28.575,32.8346874 28.449,33.1546874 C25.871,39.7356874 19.465,44.3956874 11.971,44.3956874 C7.354,44.3956874 3.153,42.6216874 0,39.8776874 C1.737,39.1986874 3.608,37.4026874 4.023,36.1156874 L4.023,36.1156874 Z"
            id="Path"
            fill="url(#linearGradient-2)"
            data-spirit-id="身體-底色"
          />
          <path
            d="M42.435,22.4366874 C41.775,25.5766874 39.985,28.1866874 37.565,29.9366874 C36.465,30.9066874 32.815,32.7866874 28.705,32.1866874 C28.705,32.1866874 17.335,32.8466874 10.385,27.4766874 C6.325,24.7566874 4.095,19.7466874 5.156,14.6566874 C5.845,11.3766874 7.766,8.67668738 10.336,6.93668738 L12.676,0.266687377 C12.776,-0.0233126232 13.156,-0.0933126232 13.346,0.146687377 L16.716,4.29668738 C17.486,4.32668738 18.256,4.41668738 19.036,4.57668738 L19.746,4.72668738 L33.876,7.66668738 C34.616,7.82668738 35.326,8.03668738 36.006,8.29668738 L40.716,5.85668738 C40.996,5.71668738 41.316,5.92668738 41.296,6.23668738 L40.766,13.2766874 C41.516,14.4466874 42.056,15.7366874 42.376,17.1066874 C42.775,18.8066874 42.815,20.6166874 42.435,22.4366874 L42.435,22.4366874 Z"
            id="Path"
            fill="url(#linearGradient-3)"
            data-spirit-id="身體-光澤"
          />
          <path
            d="M41.064,5.85268738 C40.959,5.80468738 40.835,5.79768738 40.718,5.85868738 L36.009,8.29968738 C35.326,8.04068738 34.616,7.82568738 33.878,7.67168738 L19.038,4.57668738 C18.26,4.41468738 17.484,4.32668738 16.715,4.29568738 L13.35,0.146687377 C13.23,-0.00131262317 13.043,-0.0203126232 12.89,0.0466873768 L14.395,8.17868738 L23.141,19.3406874 L37.281,14.2796874 L41.064,5.85268738 Z"
            id="Path"
            fill="url(#linearGradient-4)"
            data-spirit-id="身體-頭光"
          />
          <path
            d="M40.385,21.1566874 C41.245,17.2276874 39.209,13.1846874 35.544,11.5436874 C35.01,11.3046874 34.448,11.1196874 33.872,10.9926874 C29.625,10.0626874 25.418,12.4876874 24.006,16.4856874 C24.483,12.7946874 22.479,9.13868738 19.04,7.59768738 C18.506,7.35868738 17.944,7.17368738 17.368,7.04768738 C12.77,6.04068738 8.211,8.96268738 7.204,13.5596874 C6.344,17.4886874 8.38,21.5316874 12.045,23.1726874 C12.579,23.4116874 13.141,23.5966874 13.717,23.7236874 C17.964,24.6536874 22.171,22.2286874 23.583,18.2306874 C23.106,21.9226874 25.11,25.5776874 28.549,27.1186874 C29.083,27.3576874 29.645,27.5426874 30.221,27.6686874 C34.819,28.6756874 39.378,25.7546874 40.385,21.1566874 L40.385,21.1566874 Z"
            id="Path"
            fill="url(#linearGradient-5)"
            data-spirit-id="身體-眼眶"
          />
        </g>
        <g id="藍-翅膀" transform="translate(39.021327, 37.030422)">
          <path
            d="M15.109,0.000266455633 C15.891,-0.0157335444 16.508,0.691266456 16.394,1.46526646 C16.393,1.47026646 16.393,1.47526646 16.392,1.47926646 C15.196,9.53426646 7.991,15.2072665 0,14.6342665 C0.026,14.1562665 0.072,13.6752665 0.144,13.1922665 C1.268,5.61926646 7.703,0.152266456 15.109,0.000266455633 L15.109,0.000266455633 Z"
            id="Path"
            fill="url(#linearGradient-7)"
            data-spirit-id="翅膀-底色"
          />
          <path
            d="M10.709,2.55126646 C11.307,2.33126646 11.913,2.15526646 12.528,2.02126646 C13.545,1.80026646 14.42,2.76226646 14.077,3.74426646 C13.719,4.77026646 13.238,5.74226646 12.658,6.64426646 C12.631,6.28426646 12.575,5.92226646 12.484,5.56026646 C12.403,5.23726646 12.292,4.93026646 12.167,4.63126646 C12.29,5.94526646 11.995,7.22426646 11.385,8.32626646 C10.739,9.05526646 10.015,9.71726646 9.223,10.2982665 C9.357,9.89426646 9.458,9.47426646 9.51,9.03526646 C9.55,8.70426646 9.555,8.37826646 9.545,8.05426646 C9.126,9.56226646 8.176,10.8152665 6.937,11.6502665 C6.575,11.8202665 6.207,11.9802665 5.828,12.1192665 C5.828,12.1192665 5.828,12.1192665 5.827,12.1192665 C4.562,12.5842665 3.255,12.8572665 1.925,12.9352665 C2.812,8.18226646 6.138,4.23026646 10.709,2.55126646 L10.709,2.55126646 Z"
            id="Path"
            fill="#FFFFFF"
            data-spirit-id="翅膀-白"
          />
        </g>
        <g id="藍-嘴" transform="translate(55.209026, 30.504061)">
          <path
            d="M7.00230135,3.11762774 C6.75630135,4.45662774 5.47030135,6.20462774 2.85530135,6.80062774 C2.69130135,6.83762774 2.55430135,6.67362774 2.61030135,6.51562774 C3.24430135,4.70962774 2.19730135,3.39462774 2.64430135,1.89462774 C2.85330135,1.19462774 3.79030135,-0.144372258 5.38530135,0.310627742 C6.71730135,0.691627742 7.18730135,2.11162774 7.00230135,3.11762774 Z"
            id="Path"
            fill="#FDD23E"
            data-spirit-id="嘴-底色"
          />
        </g>
        <g id="藍-左眼" transform="translate(45.322327, 15.623689)">
          <circle id="Oval" fill="#FFFFFF" cx="7.635" cy="7.635" r="7.635" data-spirit-id="藍-左眼-白底"/>
          <path
            d="M6.484,12.456 C6.178,12.434 5.873,12.375 5.573,12.279 C4.219,11.841 3.213,10.7 2.951,9.3 C2.85,8.76 3.206,8.238 3.747,8.137 C4.284,8.035 4.809,8.391 4.91,8.933 C5.038,9.614 5.527,10.169 6.185,10.382 C6.897,10.615 7.677,10.4 8.174,9.843 C8.54,9.432 9.17,9.395 9.582,9.762 C9.994,10.129 10.029,10.759 9.663,11.17 C8.85,12.079 7.668,12.542 6.484,12.456 L6.484,12.456 Z"
            id="Path"
            fill="#4C4948"
            data-spirit-id="藍-左眼-眼睛"
          />
        </g>
        <g id="藍-右眼" transform="translate(62.667327, 19.834689)">
          <circle id="Oval" fill="#FFFFFF" cx="7.635" cy="7.635" r="7.635" data-spirit-id="藍-右眼-白底" />
          <path
            d="M6.567,12.844 C6.261,12.822 5.955,12.763 5.654,12.666 C4.3,12.228 3.295,11.087 3.033,9.687 C2.932,9.146 3.288,8.625 3.829,8.524 C4.363,8.424 4.89,8.777 4.992,9.32 C5.12,10.001 5.609,10.556 6.267,10.769 C6.979,11.003 7.76,10.788 8.256,10.23 C8.623,9.818 9.253,9.782 9.664,10.149 C10.076,10.516 10.111,11.146 9.745,11.557 C8.932,12.469 7.751,12.93 6.567,12.844 L6.567,12.844 Z"
            id="Path"
            fill="#4C4948"
            data-spirit-id="藍-右眼-眼睛"
          />
        </g>
        <g id="紅-身體">
          <path
            d="M45.701327,46.7616886 L47.036327,44.5996886 C46.570327,44.0626886 46.221327,43.5156886 46.060327,43.0146886 C44.715327,38.8396886 42.067327,35.0906886 38.478327,32.7296886 C43.321327,29.4816886 45.973327,23.5186886 44.709327,17.4586886 C43.894327,13.5506886 41.600327,10.3316886 38.537327,8.25768861 L35.758327,0.314688615 C35.637327,-0.0313113853 35.183327,-0.110311385 34.952327,0.174688615 L30.944327,5.11668861 C30.028327,5.15368861 29.104327,5.25768861 28.177327,5.45068861 L10.502327,9.13568861 C9.62232702,9.31968861 8.77732702,9.57468861 7.96332702,9.88368861 L2.35432702,6.97668861 C2.02532702,6.80668861 1.63732702,7.06268861 1.66532702,7.43168861 L2.29232702,15.8156886 C0.313327016,18.9416886 -0.501672984,22.8086886 0.313327016,26.7166886 C1.90032702,34.3246886 9.08232702,39.3266886 16.663327,38.3316886 C16.719327,38.7186886 16.817327,39.1066886 16.966327,39.4886886 C20.036327,47.3266886 27.666327,52.8776886 36.592327,52.8776886 C40.742327,52.8776886 44.610327,51.6756886 47.871327,49.6036886 L45.701327,46.7616886 Z"
            id="Path"
            fill="url(#linearGradient-10)"
            data-spirit-id="紅-身體-底色"
          />
          <path
            d="M44.708327,17.4576886 C43.893327,13.5496886 41.599327,10.3306886 38.536327,8.25668861 L35.757327,0.313688615 C35.636327,-0.0323113853 35.182327,-0.111311385 34.951327,0.173688615 L30.943327,5.11568861 C30.027327,5.15268861 29.103327,5.25668861 28.176327,5.44968861 L10.502327,9.13568861 C9.62232702,9.31968861 8.77732702,9.57468861 7.96332702,9.88368861 L2.35432702,6.97668861 C2.02532702,6.80668861 1.63732702,7.06268861 1.66532702,7.43168861 L2.29232702,15.8156886 C0.313327016,18.9416886 -0.501672984,22.8086886 0.313327016,26.7166886 C1.90032702,34.3246886 9.08232702,39.3266886 16.663327,38.3316886 C23.622327,37.4316886 34.576327,35.5066886 38.477327,32.7276886 C43.321327,29.4816886 45.972327,23.5176886 44.708327,17.4576886 L44.708327,17.4576886 Z"
            id="Path"
            fill="url(#linearGradient-11)"
            data-spirit-id="紅-身體-光澤"
          />
          <path
            d="M22.107327,19.4776886 L33.517327,9.71768861 L35.402327,0.00868861475 C35.243327,-0.0213113853 35.068327,0.0286886147 34.951327,0.173688615 L30.943327,5.11568861 C30.027327,5.15268861 29.103327,5.25668861 28.176327,5.44968861 L10.502327,9.13568861 C9.62232702,9.31968861 8.77732702,9.57468861 7.96332702,9.88368861 L2.35432702,6.97668861 C2.18632702,6.88968861 2.00232702,6.91568861 1.86732702,7.00968861 L7.04532702,14.7996886 L22.107327,19.4776886 Z"
            id="Path"
            fill="url(#linearGradient-12)"
            data-spirit-id="紅-身體-頭光"
          />
          <path
            d="M40.893327,16.7656886 C39.977327,12.3776886 36.065327,9.19368861 31.590327,9.19368861 C30.938327,9.19368861 30.282327,9.26168861 29.639327,9.39568861 C24.896327,10.3846886 21.722327,14.7676886 22.107327,19.4776886 C20.910327,15.5056886 17.207327,12.7006886 13.007327,12.7006886 C12.355327,12.7006886 11.699327,12.7686886 11.056327,12.9026886 C5.92132702,13.9736886 2.61532702,19.0216886 3.68532702,24.1566886 C4.60132702,28.5446886 8.51332702,31.7286886 12.988327,31.7286886 C13.640327,31.7286886 14.296327,31.6606886 14.939327,31.5266886 C19.682327,30.5376886 22.856327,26.1546886 22.471327,21.4446886 C23.668327,25.4166886 27.371327,28.2216886 31.571327,28.2216886 C32.223327,28.2216886 32.879327,28.1536886 33.522327,28.0196886 C38.657327,26.9496886 41.964327,21.9016886 40.893327,16.7656886 Z"
            id="Path"
            fill="url(#linearGradient-13)"
            data-spirit-id="紅-身體-眼眶"
          />
        </g>
        <g id="紅-翅膀" transform="translate(31.232168, 33.479893)">
          <path
            d="M1.88115857,0.00979572022 C0.955158568,-0.0962042798 0.145158568,0.67279572 0.194158568,1.60279572 C0.194158568,1.60879572 0.195158568,1.61479572 0.195158568,1.61979572 C0.715158568,11.3057957 8.62615857,18.8357957 18.1661586,19.0467957 C18.1881586,18.4767957 18.1881586,17.9017957 18.1571586,17.3207957 C17.6681586,8.21579572 10.6461586,1.01579572 1.88115857,0.00979572022 Z"
            id="Path"
            fill="url(#linearGradient-15)"
            data-spirit-id="紅-翅膀-底色"
          />
          <path
            d="M6.81515857,3.52479572 C6.13115857,3.19779572 5.43115857,2.92079572 4.71815857,2.69379572 C3.53615857,2.31779572 2.39115857,3.36079572 2.68915857,4.56479572 C3.00015857,5.82179572 3.46115857,7.02679572 4.04915857,8.16279572 C4.12115857,7.73979572 4.22815857,7.31579572 4.37615857,6.89679572 C4.50815857,6.52279572 4.67415857,6.17079572 4.85515857,5.83079572 C4.56315857,7.37479572 4.77015857,8.92479572 5.37015857,10.2997957 C6.05515857,11.2367957 6.84015857,12.1027957 7.71415857,12.8787957 C7.60015857,12.3847957 7.52815857,11.8747957 7.51415857,11.3487957 C7.50415857,10.9517957 7.53415857,10.5637957 7.58215857,10.1817957 C7.91115857,12.0167957 8.89715857,13.6087957 10.2741586,14.7367957 C10.6841586,14.9787957 11.1021586,15.2087957 11.5371586,15.4167957 L11.5381586,15.4167957 C12.9861586,16.1097957 14.5061586,16.5777957 16.0741586,16.8197957 C15.5511586,11.0827957 12.0471586,6.02579572 6.81515857,3.52479572 L6.81515857,3.52479572 Z"
            id="Path"
            fill="#FFFFFF"
            data-spirit-id="紅-身體-白色"
          />
        </g>
        <g id="紅-嘴" transform="translate(20.364297, 26.285901)">
          <path
            d="M0,3.25378738 C-0.00497004783,5.04478738 1.23602995,7.61678738 4.47402995,9.01878738 C4.67702995,9.10678738 4.89402995,8.92778738 4.86002995,8.70978738 C4.47502995,6.22078738 6.14802995,4.77278738 5.93202995,2.72478738 C5.83102995,1.76878738 4.94202995,-0.189212615 2.76902995,0.0147873846 C0.955029952,0.183787385 0.00402995217,1.90778738 0,3.25378738 L0,3.25378738 Z"
            id="Path"
            fill="#FDD23E"
            data-spirit-id="紅-嘴-底色"
          />
        </g>
        <g id="紅-右眼" transform="translate(23.706327, 9.719689)">
          <circle id="Oval" fill="#FFFFFF" cx="8.055" cy="8.055" r="8.055" data-spirit-id="紅-右眼-底色" />
          <path
            d="M7.898,13.101 C6.399,13.101 5.01,12.43 4.178,11.248 C3.86,10.796 3.968,10.172 4.419,9.854 C4.872,9.538 5.495,9.644 5.813,10.095 C6.463,11.018 7.677,11.229 8.584,11.023 C9.563,10.805 10.239,10.157 10.394,9.289 C10.491,8.746 10.998,8.38 11.553,8.479 C12.097,8.575 12.459,9.094 12.363,9.638 C12.068,11.303 10.787,12.581 9.019,12.975 C8.643,13.06 8.267,13.101 7.898,13.101 L7.898,13.101 Z"
            id="Path"
            fill="#4C4948"
            data-spirit-id="紅-右眼-眼睛"
          />
        </g>
        <g id="紅-左眼" transform="translate(4.253327, 13.776689)">
          <circle id="Oval" fill="#FFFFFF" cx="8.055" cy="8.055" r="8.055" data-spirit-id="紅-左眼-底色" />
          <path
            d="M7.842,13.381 C6.555,13.381 5.338,12.873 4.498,11.928 C4.131,11.516 4.168,10.883 4.581,10.517 C4.992,10.149 5.625,10.186 5.992,10.6 C6.742,11.442 7.965,11.513 8.85,11.208 C9.798,10.881 10.397,10.16 10.452,9.279 C10.486,8.729 10.937,8.317 11.513,8.343 C12.064,8.377 12.483,8.852 12.449,9.404 C12.344,11.092 11.216,12.508 9.504,13.098 C8.952,13.288 8.391,13.381 7.842,13.381 L7.842,13.381 Z"
            id="Path"
            fill="#4C4948"
            data-spirit-id="紅-左眼-眼睛"
          />
        </g>
      </g>
    </g>
  </svg> -->
  <img class="blink" src="@/assets/owl-icon.svg" style="height: 120px;" alt="">
</template>

<script>
// import spiritjs from 'spiritjs'

export default {
  mounted () {
    // this.$nextTick(() => {
    //   spiritjs.loadAnimation({
    //     container: document.getElementById('spritContainer'),
    //     animationData: require('@/assets/loadingSVGJson.json'),
    //     loop: true,
    //     // yoyo: true,
    //     delay: 1.3
    //   }).then((timeline) => {
    //     timeline.play()
    //   })
    // })
  }
}
</script>

<style lang="sass" scoped>
.blink
  animation: fade 1000ms infinite
@keyframes fade
  0%
    opacity: 1
  50%
    opacity: 0.5
  100%
    opacity: 1
</style>
